import { render, staticRenderFns } from "./r-map-group-dialog.vue?vue&type=template&id=87ee90c4&scoped=true"
import script from "./r-map-group-dialog.vue?vue&type=script&lang=js"
export * from "./r-map-group-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-map-group-dialog.vue?vue&type=style&index=0&id=87ee90c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ee90c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87ee90c4')) {
      api.createRecord('87ee90c4', component.options)
    } else {
      api.reload('87ee90c4', component.options)
    }
    module.hot.accept("./r-map-group-dialog.vue?vue&type=template&id=87ee90c4&scoped=true", function () {
      api.rerender('87ee90c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-group/r-map-group-dialog.vue"
export default component.exports